import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const List = styled.ul`
  color: ${props => (props.inverse ? '#ffffff' : '#000000')};
  font-size: 1rem;
  line-height: 1.2;
  ${props => (props.inline ? 'padding-left: 0' : '')};
`;

let UL = ({ children, ...otherProps }) => (
  <List {...otherProps}>{children}</List>
);

UL.propTypes = {
  children: PropTypes.node.isRequired
};

export default UL;



// WEBPACK FOOTER //
// ./src/components/UL.js